module.exports = __webpack_public_path__ + "img/pocket_cn.40ac14b.jpg";